import React from "react";
import Navbar from "../components/Navbar";
import heroImage from "../assets/20250105_180447.jpg";
import Footer from "../components/Footer";
import HeroVenue from "../components/Hero_venue";
import ImageGallery from "../components/imageGalleryComp";
import Canonical from "../components/canonical";
export function Gallery() {
  const heroName = "gallery";
  return (
    <React.Fragment>
      <Canonical />
      <HeroVenue heroAreaName={heroName} imageSrc={heroImage} />
      <Navbar linkName="Home" />
      <div className="bg-[#075AAA] w-full mx-auto flex flex-col items-center justify-center text-white">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>Gallery</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 text-center">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            During our events and training sessions we sometimes capture images,
            these will be placed on this page for you to have a look at.
          </p>
        </div>
        <div className="w-full bg-white py-4">
          <div className="max-w-[1248px] mx-auto text-center justify-center columns-2 sm:columns-2 lg:columns-5 md:columns-3">
            <ImageGallery />
          </div>
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
